module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Oooh you tried to navigate to a page your not allowed too use...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "5px"
    }
  }, [_vm._v("We know you did this   •`_´•")])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7439ce06","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageNotAllowed.vue
// module id = 647
// module chunks = 1